import { render } from "./AlzataIcon.vue?vue&type=template&id=cc624dd2"
import script from "./AlzataIcon.vue?vue&type=script&lang=js"
export * from "./AlzataIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__